import React from 'react'
import { Avatar } from 'antd'
import { useEmployeePublicInfo } from '@/common/hooks/useEmployeePublicInfo.tsx'

const AVATAR_COLORS = [
  '#f56a00',
  '#7265e6',
  '#ffbf00',
  '#00a2ae',
  '#1890ff',
  '#52c41a',
  '#eb2f96',
  '#722ed1',
]

const getAvatarColor = (name: string): string => {
  let hash = 0
  for (let i = 0; i < name.length; i++)
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

const getInitials = (name: string): string => {
  const parts = name.replace(/\(.*?\)/g, '').trim().split(' ')
  if (parts.length >= 2)
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

type InitialsAvatarProps = {
  value: string
  size?: number
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ value, size = 44 }) => {
  const initials = getInitials(value)
  const color = getAvatarColor(value)
  return (
    <Avatar
      size={size}
      style={{
        background: color,
        flexShrink: 0,
        fontSize: 16,
        fontWeight: 600,
      }}
    >
      {initials}
    </Avatar>
  )
}

type EmployeeAvatarProps = {
  employeeId: string
  size?: number
}

export const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({ employeeId, ...props }) => {
  const { getEmployeePublicInfo } = useEmployeePublicInfo()
  const employee = getEmployeePublicInfo(employeeId)

  return <InitialsAvatar {...props} value={employee?.displayName || '?'} />
}